import { render } from "./StudentEnroll.vue?vue&type=template&id=59c610fa"
import script from "./StudentEnroll.vue?vue&type=script&lang=js"
export * from "./StudentEnroll.vue?vue&type=script&lang=js"

import "./StudentEnroll.vue?vue&type=style&index=0&id=59c610fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__